import type { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { ToastMessageService } from '@shared/services/toast-message.service';
import { inject } from '@angular/core';
import { LogoutService } from '../auth/logout.service';
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _ToastMessageService = inject(ToastMessageService);
  const _logoutService = inject(LogoutService);

  function firstErrorMessage(error: any): string {
    const messages = error?.error?.Error;
    if (Array.isArray(messages) && typeof messages[0] === 'string') {
      return messages[0];
    }
    return 'Something went wrong. Please try again.';
  }

  function handleErrorMessage(error: any) {
    const messages = error?.error?.Error;
    if (Array.isArray(messages)) {
      messages.forEach((entry: any) => {
        if (typeof entry === 'string') {
          entry.split(',').forEach((msg: string) => _ToastMessageService.toastOnError('error', msg.trim()));
        }
      });
    } else {
      _ToastMessageService.toastOnError('error', firstErrorMessage(error));
    }
  }

  return next(req).pipe(map(
    (event: HttpEvent<any>) => {
      return event;
    }
  ),

    catchError(
      (error: HttpErrorResponse) => {
        switch (error.status) {
          case 401:
            _ToastMessageService.toastOnError('error', firstErrorMessage(error))
            _logoutService.logout();
            // handle not Authenticated case here
            break;

          case 403:
            handleErrorMessage(error);
            // handle not Authorized case here
            break;

          case 404:
            handleErrorMessage(error);
            // handle not found case here
            break;
          case 500:
            // handle server error case here
            handleErrorMessage(error);
            break;
          default:
            handleErrorMessage(error);
            break;
        }

        return throwError(() => error);
      })
  );
};

